/*=========================================================================================
  File Name: module-outinvoice-state.js
  Description: OutInvoice Module State
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	OutInvoices: [],
	OutInvoicesTotal: 0,
	IsLoadingTotalRecords: false
};
